import React from "react";
import { formatBytes, toGbValue } from "../data/storageUtils";

const AdminUsersTable = ({ users = [], userLimitEdits, setUserLimitEdits, savingUserId, updateUserLimit }) => {
  if (users.length === 0) {
    return (
      <table className="table mb-0">
        <tbody>
          <tr>
            <td colSpan="6" className="text-center text-muted py-4">
              No user-level storage data yet.
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table className="table mb-0">
      <thead className="table-light">
        <tr>
          <th>Sr</th>
          <th>User</th>
          <th>Role</th>
          <th>Used</th>
          <th>Limit (GB)</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {users.map((user, idx) => {
          const inputValue = userLimitEdits[user.user_id];
          const displayValue = inputValue !== undefined ? inputValue : toGbValue(user.storage_limit_bytes);
          return (
            <tr key={user.user_id}>
              <td className="text-muted">{idx + 1}</td>
              <td>
                <div className="fw-semibold">{user.user_name || user.user_id}</div>
                <div className="text-muted small">{user.email || user.user_id}</div>
              </td>
              <td>{user.user_role || "—"}</td>
              <td>{formatBytes(user.storage_used_bytes)}</td>
              <td style={{ minWidth: "140px" }}>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  className="form-control form-control-sm"
                  placeholder="0 = Unlimited"
                  value={displayValue}
                  onChange={(e) => setUserLimitEdits((prev) => ({ ...prev, [user.user_id]: e.target.value }))}
                />
                <small className="text-muted">Util: {user.utilization_pct ? `${user.utilization_pct}%` : "Unlimited"}</small>
              </td>
              <td className="text-end">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => updateUserLimit(user.user_id)}
                  disabled={savingUserId === user.user_id}
                >
                  {savingUserId === user.user_id ? "Saving..." : "Save"}
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default AdminUsersTable;
